(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6682"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6682"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7JAKl", function(module, exports) {

$parcel$export(module.exports, "OUTPUT_FORMATS", () => $5a193d7426028a6c$export$314b93693e42ef22);
$parcel$export(module.exports, "canEncode", () => $5a193d7426028a6c$export$32d8af07dd2de268);
$parcel$export(module.exports, "decode", () => $5a193d7426028a6c$export$2f872c0f2117be69);
$parcel$export(module.exports, "hasAlpha", () => $5a193d7426028a6c$export$7c6623716c246f1);
$parcel$export(module.exports, "sizeOf", () => $5a193d7426028a6c$export$30043de3fae42dd1);
$parcel$export(module.exports, "fitWithin", () => $5a193d7426028a6c$export$2cf9958cd81e83ad);
$parcel$export(module.exports, "draw", () => $5a193d7426028a6c$export$e529deb2bfd496dc);
$parcel$export(module.exports, "encode", () => $5a193d7426028a6c$export$c564cdbbe6da493);
$parcel$export(module.exports, "renameExtension", () => $5a193d7426028a6c$export$a7b7f54182084c78);
$parcel$export(module.exports, "saveBlob", () => $5a193d7426028a6c$export$9016c9576545678);
$parcel$export(module.exports, "formatBytes", () => $5a193d7426028a6c$export$e1a3971de07c83b5);
// Decoding, encoding and the small conveniences that both browser tools need.
//
// Everything here works on the bytes the visitor picked and never touches the
// network. That is the whole promise of /tools, so nothing in this file may
// grow a fetch of the image itself.
// Feature-detected once per page rather than per file. A browser that cannot
// encode a format answers toBlob with a PNG instead of failing, so asking for
// AVIF and trusting the result would silently hand out a mislabelled file.
const $5a193d7426028a6c$var$encoderSupport = new Map();
const $5a193d7426028a6c$export$314b93693e42ef22 = [
    {
        mime: 'image/png',
        label: 'PNG',
        extension: 'png',
        lossy: false,
        note: 'Lossless, keeps transparency'
    },
    {
        mime: 'image/jpeg',
        label: 'JPEG',
        extension: 'jpg',
        lossy: true,
        note: 'Small, no transparency'
    },
    {
        mime: 'image/webp',
        label: 'WebP',
        extension: 'webp',
        lossy: true,
        note: 'Small and keeps transparency'
    },
    {
        mime: 'image/avif',
        label: 'AVIF',
        extension: 'avif',
        lossy: true,
        note: 'Smallest, not encodable everywhere'
    }
];
function $5a193d7426028a6c$export$32d8af07dd2de268(mime) {
    if (mime === 'image/png') return Promise.resolve(true);
    if (!$5a193d7426028a6c$var$encoderSupport.has(mime)) $5a193d7426028a6c$var$encoderSupport.set(mime, new Promise((resolve)=>{
        const probe = document.createElement('canvas');
        probe.width = 1;
        probe.height = 1;
        try {
            probe.toBlob((blob)=>resolve(!!blob && blob.type === mime), mime, 0.9);
        } catch (err) {
            resolve(false);
        }
    }));
    return $5a193d7426028a6c$var$encoderSupport.get(mime);
}
async function $5a193d7426028a6c$export$2f872c0f2117be69(file) {
    if (typeof createImageBitmap === 'function') try {
        return await createImageBitmap(file, {
            imageOrientation: 'from-image'
        });
    } catch (err) {
    // Falls through. Either the format is one this browser cannot
    // decode, which the fallback will report the same way, or the
    // options argument is unsupported, which the fallback handles.
    }
    const url = URL.createObjectURL(file);
    try {
        return await new Promise((resolve, reject)=>{
            const img = new Image();
            img.onload = ()=>resolve(img);
            img.onerror = ()=>reject(new Error('This browser cannot decode that image'));
            img.src = url;
        });
    } finally{
        // Revoking immediately is safe: a loaded <img> keeps its own decoded
        // copy, and a failed one has nothing left to read.
        URL.revokeObjectURL(url);
    }
}
function $5a193d7426028a6c$export$7c6623716c246f1(image) {
    const PROBE = 128;
    const { width: width, height: height } = $5a193d7426028a6c$export$30043de3fae42dd1(image);
    const w = Math.max(1, Math.min(PROBE, width));
    const h = Math.max(1, Math.min(PROBE, height));
    const canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext('2d', {
        willReadFrequently: true
    });
    ctx.drawImage(image, 0, 0, w, h);
    const { data: data } = ctx.getImageData(0, 0, w, h);
    for(let i = 3; i < data.length; i += 4){
        if (data[i] < 255) return true;
    }
    return false;
}
function $5a193d7426028a6c$export$30043de3fae42dd1(image) {
    return {
        width: image.width || image.naturalWidth,
        height: image.height || image.naturalHeight
    };
}
function $5a193d7426028a6c$export$2cf9958cd81e83ad(width, height, maxWidth, maxHeight) {
    const scale = Math.min(maxWidth ? maxWidth / width : 1, maxHeight ? maxHeight / height : 1, 1);
    return {
        width: Math.max(1, Math.round(width * scale)),
        height: Math.max(1, Math.round(height * scale))
    };
}
function $5a193d7426028a6c$export$e529deb2bfd496dc(image, width, height, background) {
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    if (background) {
        ctx.fillStyle = background;
        ctx.fillRect(0, 0, width, height);
    }
    ctx.drawImage(image, 0, 0, width, height);
    return canvas;
}
function $5a193d7426028a6c$export$c564cdbbe6da493(canvas, mime, quality) {
    return new Promise((resolve, reject)=>{
        canvas.toBlob((blob)=>blob ? resolve(blob) : reject(new Error(`Could not encode as ${mime}`)), mime, // Undefined rather than a number for PNG: passing a quality to a
        // lossless encoder is meaningless, and some browsers take it as a
        // hint to switch to a lossy one.
        quality);
    });
}
function $5a193d7426028a6c$export$a7b7f54182084c78(filename, extension) {
    const stem = filename.replace(/\.[^.]+$/, '') || 'image';
    return `${stem}.${extension}`;
}
function $5a193d7426028a6c$export$9016c9576545678(blob, filename) {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    // A revoke on the next tick rather than straight away. Chrome starts the
    // download asynchronously and reads the URL after the click returns.
    setTimeout(()=>URL.revokeObjectURL(url), 1000);
}
function $5a193d7426028a6c$export$e1a3971de07c83b5(bytes) {
    if (!bytes) return '0 B';
    const units = [
        'B',
        'KB',
        'MB',
        'GB'
    ];
    const power = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
    const value = bytes / Math.pow(1024, power);
    return `${value >= 100 || power === 0 ? Math.round(value) : value.toFixed(1)} ${units[power]}`;
}

});

parcelRegister("8hRDK", function(module, exports) {

$parcel$export(module.exports, "RUNTIME_BYTES", () => $60898514af44a1e9$export$b5bf5d5b2906164d);
$parcel$export(module.exports, "explainLoadError", () => $60898514af44a1e9$export$53fc5a413a89d8a9);
$parcel$export(module.exports, "loadRuntime", () => $60898514af44a1e9$export$35ec577535b9239b);
$parcel$export(module.exports, "sessionFor", () => $60898514af44a1e9$export$e7ac982469b12cda);
// Getting a model into the browser and ready to run.
//
// Two tools need this now, so it sits here rather than inside either of them:
// the runtime is loaded once per page whatever asks for it, and the download of
// a model is the slowest thing on the page and is worth caching exactly once.
//
// The files come from this origin, put there by scripts/build-tools-assets.js.
// Nothing here reaches anywhere else, which is what lets the pages promise that
// a picture never leaves the machine.
const $60898514af44a1e9$var$RUNTIME_URL = '/plugins/onnxruntime/ort.wasm.min.js';
const $60898514af44a1e9$var$RUNTIME_PATH = '/plugins/onnxruntime/';
const $60898514af44a1e9$var$MODEL_CACHE = 'imageserver-tools-models-v1';
const $60898514af44a1e9$export$b5bf5d5b2906164d = 12739637;
function $60898514af44a1e9$export$53fc5a413a89d8a9(err) {
    if (typeof navigator !== 'undefined' && navigator.onLine === false) return "You are offline, and this tool has not been downloaded to this browser yet. Connect once and try again; after that it works without a connection.";
    const message = err && err.message ? err.message : '';
    if (/runtime|model|fetch|network|load/i.test(message)) return 'The tool could not be downloaded. Check your connection and try again.';
    return message || 'Something went wrong. Try again.';
}
let $60898514af44a1e9$var$runtimePromise = null;
const $60898514af44a1e9$var$sessions = new Map();
function $60898514af44a1e9$export$35ec577535b9239b() {
    if ($60898514af44a1e9$var$runtimePromise) return $60898514af44a1e9$var$runtimePromise;
    $60898514af44a1e9$var$runtimePromise = new Promise((resolve, reject)=>{
        const script = document.createElement('script');
        script.src = $60898514af44a1e9$var$RUNTIME_URL;
        script.onload = ()=>{
            if (!window.ort) {
                reject(new Error('The image runtime loaded but did not start'));
                return;
            }
            // Without this the runtime looks for its wasm next to the page.
            window.ort.env.wasm.wasmPaths = $60898514af44a1e9$var$RUNTIME_PATH;
            // The page is not cross-origin isolated, so SharedArrayBuffer is
            // unavailable and threads cannot work. Saying so up front skips a
            // failed worker start and a console error on every run.
            window.ort.env.wasm.numThreads = 1;
            resolve(window.ort);
        };
        script.onerror = ()=>{
            // Gone again, so the next attempt adds a fresh tag instead of
            // waiting on one that has already failed.
            script.remove();
            reject(new Error('Could not load the image runtime'));
        };
        document.head.appendChild(script);
    });
    // A failed load is not kept: without this, every later attempt on the page
    // would get the same rejection and "Try again" could never work.
    $60898514af44a1e9$var$runtimePromise.catch(()=>{
        $60898514af44a1e9$var$runtimePromise = null;
    });
    return $60898514af44a1e9$var$runtimePromise;
}
/**
 * The model bytes, from the Cache Storage if they are already there.
 *
 * Read with a stream rather than as one blob so a large model can report how
 * far along it is. Cache Storage needs a secure context, so a plain http origin
 * quietly falls back to downloading each time.
 */ async function $60898514af44a1e9$var$fetchModel(model, onProgress) {
    let cache = null;
    try {
        cache = await caches.open($60898514af44a1e9$var$MODEL_CACHE);
        const hit = await cache.match(model.file);
        if (hit) return await hit.arrayBuffer();
    } catch (err) {
    // No Cache Storage here. Not worth telling anyone about; it costs a
    // download on the next visit and nothing else.
    }
    const response = await fetch(model.file);
    if (!response.ok) throw new Error(`Could not load the ${model.label.toLowerCase()} model`);
    const total = Number(response.headers.get('content-length')) || model.bytes;
    const reader = response.body?.getReader();
    if (!reader) return await response.arrayBuffer();
    const chunks = [];
    let received = 0;
    for(;;){
        const { done: done, value: value } = await reader.read();
        if (done) break;
        chunks.push(value);
        received += value.length;
        if (onProgress) onProgress(Math.min(1, received / total));
    }
    const bytes = new Uint8Array(received);
    let offset = 0;
    for (const chunk of chunks){
        bytes.set(chunk, offset);
        offset += chunk.length;
    }
    // Cached from the bytes rather than from a clone of the response. Handing
    // the cache a clone makes it consume the whole body before this reader sees
    // a chunk, which leaves the progress bar at nothing for the entire download
    // and then finishes it in one jump.
    if (cache) try {
        await cache.put(model.file, new Response(bytes));
    } catch (err) {
    // A full quota, or a browser that will not store something this
    // large. It costs a download on the next visit and nothing else.
    }
    return bytes.buffer;
}
function $60898514af44a1e9$export$e7ac982469b12cda(model, onProgress) {
    if ($60898514af44a1e9$var$sessions.has(model.id)) return $60898514af44a1e9$var$sessions.get(model.id);
    const promise = (async ()=>{
        const ort = await $60898514af44a1e9$export$35ec577535b9239b();
        const bytes = await $60898514af44a1e9$var$fetchModel(model, onProgress);
        return ort.InferenceSession.create(bytes, {
            executionProviders: [
                'wasm'
            ],
            graphOptimizationLevel: 'all'
        });
    })();
    // Stored before it resolves so two images picked in quick succession share
    // one download, and dropped again on failure so a retry is not stuck with
    // a rejected promise.
    $60898514af44a1e9$var$sessions.set(model.id, promise);
    promise.catch(()=>$60898514af44a1e9$var$sessions.delete(model.id));
    return promise;
}

});

parcelRegister("65gAn", function(module, exports) {

$parcel$export(module.exports, "wirePicker", () => $46e0134a81c5c949$export$a7ad1357dc53be0f);
$parcel$export(module.exports, "blockStrayDrops", () => $46e0134a81c5c949$export$9587a56f399e19d6);
$parcel$export(module.exports, "initColourPicker", () => $46e0134a81c5c949$export$54c51a5e259d1ae);
// The input controls both tools share: a drop zone that also takes a click or a
// paste, and the colour swatch picker beside it.
//
// Dropzone.js is already on the page from the header, but it exists to POST
// files somewhere. These tools must not send anything, so they take the files
// straight out of the event instead.
/**
 * Wire a drop zone.
 *
 * @param {object}   options
 * @param {Element}  options.zone      Element that accepts drops and clicks.
 * @param {Element}  options.input     The <input type="file"> behind it.
 * @param {boolean}  options.multiple  Whether more than one file is useful.
 * @param {Function} options.onFiles   Called with an array of image Files.
 * @returns {Function} Removes the paste listener, which is the only one that
 *                     outlives the elements.
 */ function $46e0134a81c5c949$export$a7ad1357dc53be0f({ zone: zone, input: input, multiple: multiple = false, onFiles: onFiles }) {
    const imagesOnly = (files)=>Array.from(files).filter((file)=>file.type.startsWith('image/'));
    // Whatever is left out is said, in a toast: the drop zone is often hidden
    // by then, and a file that silently does nothing reads as a broken tool.
    const tell = (message)=>{
        if (window.ui && typeof window.ui.toast === 'function') window.ui.toast(message, 'warning');
    };
    const hand = (files)=>{
        const all = Array.from(files);
        const images = imagesOnly(all);
        const skipped = all.length - images.length;
        if (skipped) tell(skipped === 1 && all.length === 1 ? `${all[0].name} is not an image, so there is nothing to do with it here.` : `${skipped} of ${all.length} files are not images and were left out.`);
        if (!images.length) return;
        if (!multiple && images.length > 1) tell(`This tool works on one image at a time, so only ${images[0].name} was opened.`);
        onFiles(multiple ? images : [
            images[0]
        ]);
    };
    zone.addEventListener('click', (event)=>{
        // input.click() dispatches a click that bubbles back here if the input
        // sits inside the zone, and opening the picker from its own click event
        // never stops.
        if (event.target === input) return;
        input.click();
    });
    zone.addEventListener('keydown', (event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            input.click();
        }
    });
    input.addEventListener('change', ()=>{
        hand(input.files);
        // Cleared so that picking the same file twice in a row still fires a
        // change event, which is what someone does after tweaking a setting.
        input.value = '';
    });
    // dragenter and dragleave fire for every child element the pointer crosses,
    // so a counter decides when the pointer has really left rather than the
    // events alone.
    let depth = 0;
    const setDragging = (on)=>zone.classList.toggle('is-dragging', on);
    zone.addEventListener('dragenter', (event)=>{
        event.preventDefault();
        depth += 1;
        setDragging(true);
    });
    zone.addEventListener('dragover', (event)=>{
        event.preventDefault();
        event.dataTransfer.dropEffect = 'copy';
    });
    zone.addEventListener('dragleave', ()=>{
        depth = Math.max(0, depth - 1);
        if (depth === 0) setDragging(false);
    });
    zone.addEventListener('drop', (event)=>{
        event.preventDefault();
        depth = 0;
        setDragging(false);
        hand(event.dataTransfer.files);
    });
    // A screenshot on the clipboard is the shortest path into either tool, so
    // the whole document listens rather than only the focused zone.
    const onPaste = (event)=>{
        const files = Array.from(event.clipboardData?.files || []);
        if (files.length) {
            event.preventDefault();
            hand(files);
        }
    };
    document.addEventListener('paste', onPaste);
    return ()=>document.removeEventListener('paste', onPaste);
}
function $46e0134a81c5c949$export$9587a56f399e19d6() {
    for (const type of [
        'dragover',
        'drop'
    ])window.addEventListener(type, (event)=>{
        const target = event.target;
        if (target instanceof Element && target.closest('[data-picker-zone]')) return;
        event.preventDefault();
    });
}
function $46e0134a81c5c949$export$54c51a5e259d1ae() {
    if (typeof window.Coloris === 'undefined') return;
    window.Coloris({
        el: '[data-coloris]',
        theme: 'pill',
        themeMode: 'auto',
        alpha: false,
        swatches: [
            '#ffffff',
            '#e2e8f0',
            '#94a3b8',
            '#334155',
            '#0f172a',
            '#ef4444',
            '#f97316',
            '#f59e0b',
            '#22c55e',
            '#14b8a6',
            '#0ea5e9',
            '#3b82f6',
            '#6366f1',
            '#8b5cf6',
            '#ec4899'
        ]
    });
}

});

parcelRegister("1Euqv", function(module, exports) {

$parcel$export(module.exports, "wireAccountSave", () => $134120eb769dffbc$export$ef5aa585a850b1f);
// The one thing on these pages that leaves the machine.
//
// Everything else here is a promise that nothing is sent anywhere. This is the
// deliberate exception: a signed-in visitor presses a button and the finished
// picture is uploaded to their own account, encrypted like any other upload,
// through /upload/web rather than through anything new. That route already
// knows about plan limits, quotas, folders and the account's upload rules, and
// reusing it means a picture saved from a tool is not a second kind of upload
// with a second set of behaviours to keep in step.
//
// Because it is the exception, the button says what it does, it is never the
// default action, and nothing here runs unless it is pressed.
const $134120eb769dffbc$var$UPLOAD_URL = '/upload/web';
function $134120eb769dffbc$export$e3fbe444a169a808() {
    const node = document.getElementById('toolAccount');
    if (!node || node.dataset.loggedIn !== '1' || !node.dataset.csrf) return null;
    return {
        token: node.dataset.csrf
    };
}
/**
 * Upload one blob and answer with the link.
 *
 * The route replies with JSON on success and, depending on which check refused,
 * either JSON or a bare string on failure, so both shapes are handled rather
 * than assuming the happy one.
 */ async function $134120eb769dffbc$var$upload(blob, filename, token) {
    const form = new FormData();
    form.append('file', blob, filename);
    const response = await fetch($134120eb769dffbc$var$UPLOAD_URL, {
        method: 'POST',
        headers: {
            'X-CSRF-TOKEN': token
        },
        // Same-origin only, and the cookie is what identifies the account.
        credentials: 'same-origin',
        body: form
    });
    const raw = await response.text();
    let parsed = null;
    try {
        parsed = JSON.parse(raw);
    } catch (err) {
    // A plain-text error, which some of the checks in that route still send.
    }
    if (!response.ok) throw new Error(parsed && parsed.error || raw || `Upload failed (${response.status})`);
    if (!parsed || !parsed.url) throw new Error('The upload finished but did not come back with a link');
    return parsed.url;
}
/** One saved link, with a button that copies it. */ function $134120eb769dffbc$var$linkRow(name, url) {
    const row = document.createElement('li');
    row.className = 'flex items-center gap-3 p-3';
    row.innerHTML = `
        <i class="fa-solid fa-circle-check text-emerald-500 shrink-0"></i>
        <div class="min-w-0 flex-1">
            <p data-name class="truncate text-xs font-semibold text-slate-900 dark:text-white"></p>
            <a data-link target="_blank" rel="noopener"
               class="block truncate text-xs text-blue-600 hover:underline dark:text-blue-400"></a>
        </div>
        <button type="button" data-copy
            class="shrink-0 inline-flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-xs font-medium bg-slate-100 dark:bg-gray-700 border border-slate-200 dark:border-gray-600 text-slate-700 dark:text-slate-200 hover:bg-slate-200 dark:hover:bg-gray-600 transition-colors">
            <i class="fa-regular fa-copy"></i>
            <span>Copy</span>
        </button>`;
    row.querySelector('[data-name]').textContent = name;
    const link = row.querySelector('[data-link]');
    link.href = url;
    link.textContent = url;
    const copy = row.querySelector('[data-copy]');
    copy.addEventListener('click', async ()=>{
        try {
            await navigator.clipboard.writeText(url);
            copy.querySelector('span').textContent = 'Copied';
            setTimeout(()=>{
                copy.querySelector('span').textContent = 'Copy';
            }, 1500);
        } catch (err) {
            // Clipboard access can be refused. The link is on screen and
            // selectable either way, so this is not worth an alert.
            copy.querySelector('span').textContent = 'Press Ctrl+C';
        }
    });
    return row;
}
function $134120eb769dffbc$export$ef5aa585a850b1f({ button: button, panel: panel, list: list, error: error, collect: collect }) {
    if (!button) return false;
    const context = $134120eb769dffbc$export$e3fbe444a169a808();
    if (!context) {
        // No account, so the button would only ever produce a login redirect.
        button.hidden = true;
        return false;
    }
    button.hidden = false;
    button.addEventListener('click', async ()=>{
        const original = button.innerHTML;
        button.disabled = true;
        if (error) error.hidden = true;
        let items = [];
        try {
            items = (await collect()).filter((item)=>item && item.blob);
        } catch (err) {
            if (error) {
                error.hidden = false;
                error.textContent = err.message || 'Could not prepare the image';
            }
            button.disabled = false;
            return;
        }
        if (!items.length) {
            button.disabled = false;
            return;
        }
        // Uploaded one at a time rather than all at once: each one is a full
        // request through the encryption and storage path, and a browser that
        // opens ten of those in parallel gets rate limited by our own route.
        let saved = 0;
        try {
            for (const item of items){
                button.innerHTML = items.length > 1 ? `<i class="fa-solid fa-circle-notch fa-spin"></i> Saving ${saved + 1} of ${items.length}` : '<i class="fa-solid fa-circle-notch fa-spin"></i> Saving';
                const url = await $134120eb769dffbc$var$upload(item.blob, item.name, context.token);
                list.prepend($134120eb769dffbc$var$linkRow(item.name, url));
                panel.hidden = false;
                saved += 1;
            }
        } catch (err) {
            if (error) {
                error.hidden = false;
                error.textContent = saved ? `${saved} saved, then: ${err.message}` : err.message;
            }
        } finally{
            button.disabled = false;
            button.innerHTML = original;
        }
    });
    return true;
}

});

parcelRegister("iPsZ0", function(module, exports) {

$parcel$export(module.exports, "wireCopy", () => $db5378cf31720742$export$7167b346a0f58311);
// Putting a finished picture on the clipboard.
//
// The people these tools are for paste into Discord more often than they
// attach a file, so a copy button sits next to every "Save image" on the tools
// that produce one picture. It is a convenience on top of saving, never a
// replacement, and on a browser that cannot write images to the clipboard it
// is simply not shown.
/** Whether this browser can put an image on the clipboard at all. */ function $db5378cf31720742$export$9cdf378d4048dd07() {
    return Boolean(window.isSecureContext && navigator.clipboard && typeof navigator.clipboard.write === 'function' && typeof window.ClipboardItem === 'function');
}
/**
 * The picture as PNG, the one image type every clipboard takes. A JPEG or WebP
 * result is drawn once more and re-encoded; nothing about it changes but the
 * container, and the saved file keeps the format that was picked.
 */ async function $db5378cf31720742$var$asPng(blob) {
    if (blob.type === 'image/png') return blob;
    const bitmap = await createImageBitmap(blob);
    const canvas = document.createElement('canvas');
    canvas.width = bitmap.width;
    canvas.height = bitmap.height;
    canvas.getContext('2d').drawImage(bitmap, 0, 0);
    bitmap.close();
    return new Promise((resolve, reject)=>{
        canvas.toBlob((png)=>png ? resolve(png) : reject(new Error('Could not prepare the image')), 'image/png');
    });
}
function $db5378cf31720742$var$tell(message, kind) {
    if (window.ui && typeof window.ui.toast === 'function') window.ui.toast(message, kind);
}
function $db5378cf31720742$export$7167b346a0f58311({ button: button, mirror: mirror, collect: collect }) {
    if (!button || !$db5378cf31720742$export$9cdf378d4048dd07()) return;
    button.hidden = false;
    if (mirror) {
        const follow = ()=>{
            button.disabled = mirror.disabled;
        };
        follow();
        new MutationObserver(follow).observe(mirror, {
            attributes: true,
            attributeFilter: [
                'disabled'
            ]
        });
    }
    const label = button.querySelector('[data-copy-label]');
    const idle = label ? label.textContent : '';
    button.addEventListener('click', async ()=>{
        try {
            // The item is handed a promise rather than a finished blob: the
            // write has to start inside the click, and rendering a large
            // result can take longer than a browser keeps that window open.
            const png = Promise.resolve(collect()).then((result)=>{
                if (!result || !result.blob) throw new Error('Nothing to copy yet');
                return $db5378cf31720742$var$asPng(result.blob);
            });
            await navigator.clipboard.write([
                new window.ClipboardItem({
                    'image/png': png
                })
            ]);
            if (label) {
                label.textContent = 'Copied';
                setTimeout(()=>{
                    label.textContent = idle;
                }, 1600);
            }
            $db5378cf31720742$var$tell('Image copied. Paste it wherever you need it.', 'success');
        } catch (err) {
            $db5378cf31720742$var$tell('The image could not be copied here. Use Save image instead.', 'error');
        }
    });
}

});

parcelRegister("5Yt4b", function(module, exports) {

$parcel$export(module.exports, "wireOffline", () => $45991a5cfac9118c$export$7f412dbbe40928e4);
// "Make this tool work offline": the runtime and a model, stored on request.
//
// Without this, a model tool works offline only on a page where it has already
// run, because the runtime lives in that page's memory. With it, the four
// files a model tool needs are kept in Cache Storage and a small service worker
// (src/assets/sw/tools-sw.js) answers for them, so a page opened later works
// with no connection at all. It is a visible, opt-in download with its size on
// the button, not something that happens behind the visitor's back.

var $7JAKl = parcelRequire("7JAKl");
const $45991a5cfac9118c$var$CACHE = 'imageserver-tools-models-v1'; // shared with tools/onnx.js and the worker
const $45991a5cfac9118c$var$WORKER_URL = '/tools/sw.js';
// What the runtime is made of. Sizes are what the button quotes before the
// download starts; the download itself counts real bytes.
const $45991a5cfac9118c$var$RUNTIME_FILES = [
    {
        url: '/plugins/onnxruntime/ort.wasm.min.js',
        type: 'text/javascript',
        bytes: 46627
    },
    {
        url: '/plugins/onnxruntime/ort-wasm-simd-threaded.mjs',
        type: 'text/javascript',
        bytes: 26583
    },
    {
        url: '/plugins/onnxruntime/ort-wasm-simd-threaded.wasm',
        type: 'application/wasm',
        bytes: 12666427
    }
];
function $45991a5cfac9118c$export$1a813761451f9760() {
    return Boolean(window.isSecureContext && 'serviceWorker' in navigator && 'caches' in window);
}
function $45991a5cfac9118c$var$filesFor(model) {
    return [
        ...$45991a5cfac9118c$var$RUNTIME_FILES,
        {
            url: model.file,
            type: 'application/octet-stream',
            bytes: model.bytes
        }
    ];
}
async function $45991a5cfac9118c$export$1f1224dc11714ba1(model) {
    if (!$45991a5cfac9118c$export$1a813761451f9760()) return false;
    try {
        const cache = await caches.open($45991a5cfac9118c$var$CACHE);
        const hits = await Promise.all($45991a5cfac9118c$var$filesFor(model).map((file)=>cache.match(file.url)));
        const registered = await navigator.serviceWorker.getRegistration('/tools/');
        return hits.every(Boolean) && Boolean(registered);
    } catch (err) {
        return false;
    }
}
/** Download and store what is missing, reporting 0 to 1 across all of it. */ async function $45991a5cfac9118c$var$prepare(model, onProgress) {
    await navigator.serviceWorker.register($45991a5cfac9118c$var$WORKER_URL, {
        scope: '/tools/'
    });
    const cache = await caches.open($45991a5cfac9118c$var$CACHE);
    const files = $45991a5cfac9118c$var$filesFor(model);
    const missing = [];
    for (const file of files)if (!await cache.match(file.url)) missing.push(file);
    const total = missing.reduce((sum, file)=>sum + file.bytes, 0) || 1;
    let done = 0;
    for (const file of missing){
        const response = await fetch(file.url, {
            cache: 'no-store'
        });
        if (!response.ok || !response.body) throw new Error(`Could not download ${file.url}`);
        const reader = response.body.getReader();
        const chunks = [];
        for(;;){
            const { done: finished, value: value } = await reader.read();
            if (finished) break;
            chunks.push(value);
            done += value.length;
            if (onProgress) onProgress(Math.min(1, done / total));
        }
        // Stored with its type: the runtime compiles the WebAssembly as a
        // stream and imports the glue module, and both refuse a response
        // without the right one.
        await cache.put(file.url, new Response(new Blob(chunks, {
            type: file.type
        }), {
            headers: {
                'Content-Type': file.type
            }
        }));
    }
    await navigator.serviceWorker.ready;
}
function $45991a5cfac9118c$export$7f412dbbe40928e4({ root: root, button: button, note: note, model: model }) {
    if (!root || !$45991a5cfac9118c$export$1a813761451f9760()) return ()=>{};
    root.hidden = false;
    const label = button.querySelector('[data-offline-label]');
    let busy = false;
    const sizeOf = (m)=>$45991a5cfac9118c$var$filesFor(m).reduce((sum, file)=>sum + file.bytes, 0);
    const refresh = async ()=>{
        if (busy) return;
        const current = model();
        if (await $45991a5cfac9118c$export$1f1224dc11714ba1(current)) {
            button.hidden = true;
            note.textContent = `Ready offline. This tool now works in this browser without a connection.`;
        } else {
            button.hidden = false;
            button.disabled = false;
            label.textContent = `Make this tool work offline (${(0, $7JAKl.formatBytes)(sizeOf(current))})`;
            const which = current.label ? `the ${current.label} model` : 'the model';
            note.textContent = `Stores the runtime and ${which} in this browser, so a page opened later works without a connection.`;
        }
    };
    button.addEventListener('click', async ()=>{
        if (busy) return;
        busy = true;
        button.disabled = true;
        const current = model();
        try {
            await $45991a5cfac9118c$var$prepare(current, (fraction)=>{
                label.textContent = `Downloading, ${Math.round(fraction * 100)}%`;
            });
            busy = false;
            await refresh();
        } catch (err) {
            busy = false;
            button.disabled = false;
            label.textContent = 'Try again';
            note.textContent = navigator.onLine === false ? 'You are offline. Connect, then try again.' : 'The download did not finish. Try again.';
        }
    });
    refresh();
    return refresh;
}

});

// The upscaler on /tools/upscale.
//
// The only tool here that turns a picture away. Everything else on /tools gets
// slower with a big file; this one gets slower in a way nobody would sit
// through, so the limit is part of the tool rather than an apology for it, and
// the refusal says how big the picture is, what the limit is and why.
// Making a small picture bigger by inventing the detail.
//
// Real-ESRGAN in its compact form: 4,7 MB, the same weight as the fast
// background-removal model, and BSD-3 licensed. It always produces four times
// the width and four times the height; anything else is that result resampled
// down afterwards.
//
// The reason this tool has a size limit and the others do not is the shape of
// the work. The background remover looks at a fixed 320x320 copy however large
// the picture is. This runs over every input pixel and writes sixteen, so the
// cost grows with the picture, and it grows fast: measured on one core through
// WebAssembly it manages roughly fourteen thousand input pixels a second. A
// 512 pixel square is about twenty seconds. A full HD frame would be two and a
// half minutes and would need a four hundred megabyte tensor to hold the
// answer, which is why MAX_INPUT_EDGE exists and is not negotiable at runtime.

var $7JAKl = parcelRequire("7JAKl");

var $8hRDK = parcelRequire("8hRDK");
const $88f1525ed393d6e7$export$12625b631ae5ca7f = {
    id: 'upscale-general-x4',
    file: '/models/realesr-general-x4v3.onnx',
    label: 'Upscaler',
    bytes: 4871181
};
const $88f1525ed393d6e7$export$fae5d17304677194 = 4;
const $88f1525ed393d6e7$export$7a9e452c85461233 = 512;
// Rows of the picture handled per pass. Three passes for a picture at the size
// limit, which is enough for the progress to mean something, and one pass with
// no overhead at all for the small pictures this is mostly used on.
const $88f1525ed393d6e7$var$STRIP_ROWS = 192;
// Rows carried into the pass on each side of a strip and thrown away again.
//
// Without it a strip has no idea what sits just outside it, and the seam is
// glaring: measured against a single pass over the whole picture, a strip with
// no padding is out by 158 of 255 at the join. Padding is what buys that back,
// and the numbers say exactly how much is needed. Against a checkerboard, which
// is the worst case for a network that invents detail:
//
//     pad  8   out by 14 of 255
//     pad 16   out by  3
//     pad 24   out by  0.5
//     pad 32   out by  0.000, identical
//
// Thirty-two is where the network stops being able to see any further, so the
// result is the same image a single pass would have produced rather than a
// close one. Real-ESRGAN's own tiler settles for ten and a visible seam. The
// cost here is a quarter more work at the size limit and none below it.
const $88f1525ed393d6e7$var$STRIP_PAD = 32;
/** A canvas holding the picture, ready to be read a strip at a time. */ function $88f1525ed393d6e7$var$toCanvas(image, width, height) {
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d', {
        willReadFrequently: true
    });
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(image, 0, 0, width, height);
    return canvas;
}
/** One strip of pixels as the tensor the network expects: 1x3xHxW, 0 to 1. */ function $88f1525ed393d6e7$var$toTensor(ort, imageData, width, height) {
    const pixels = width * height;
    const input = new Float32Array(3 * pixels);
    const { data: data } = imageData;
    // Channel first, and no mean or standard deviation: this network was
    // trained on plain 0 to 1 values, unlike the segmentation one next door.
    for(let p = 0; p < pixels; p += 1){
        const source = p * 4;
        input[p] = data[source] / 255;
        input[pixels + p] = data[source + 1] / 255;
        input[2 * pixels + p] = data[source + 2] / 255;
    }
    return new ort.Tensor('float32', input, [
        1,
        3,
        height,
        width
    ]);
}
/** The network's answer, written into a canvas at the given offset. */ function $88f1525ed393d6e7$var$paint(ctx, tensor, width, height, offsetY, skipTop, keepRows) {
    const pixels = width * height;
    const out = ctx.createImageData(width, keepRows);
    const values = tensor.data;
    for(let y = 0; y < keepRows; y += 1)for(let x = 0; x < width; x += 1){
        const from = (y + skipTop) * width + x;
        const to = (y * width + x) * 4;
        // The network can answer slightly outside 0 to 1, so this clamps
        // rather than trusting it; a value of 1.02 would wrap to black.
        out.data[to] = Math.max(0, Math.min(255, values[from] * 255));
        out.data[to + 1] = Math.max(0, Math.min(255, values[pixels + from] * 255));
        out.data[to + 2] = Math.max(0, Math.min(255, values[2 * pixels + from] * 255));
        out.data[to + 3] = 255;
    }
    ctx.putImageData(out, 0, offsetY);
}
/**
 * Carry the transparency across, since the network cannot.
 *
 * Real-ESRGAN works on three channels and has no idea an alpha channel exists,
 * so a cut-out would come back with its holes filled in. That matters here more
 * than it would elsewhere: the background remover next door produces exactly
 * such pictures, and the two are an obvious pair to use one after the other.
 *
 * The alpha is enlarged by plain resampling rather than by the network. There
 * is nothing for a network to invent in a coverage mask, and a smooth edge is
 * what a smooth edge should stay.
 */ function $88f1525ed393d6e7$var$restoreAlpha(canvas, image, width, height) {
    const mask = document.createElement('canvas');
    mask.width = canvas.width;
    mask.height = canvas.height;
    const maskCtx = mask.getContext('2d', {
        willReadFrequently: true
    });
    maskCtx.imageSmoothingEnabled = true;
    maskCtx.imageSmoothingQuality = 'high';
    maskCtx.drawImage(image, 0, 0, width, height, 0, 0, canvas.width, canvas.height);
    const ctx = canvas.getContext('2d', {
        willReadFrequently: true
    });
    const result = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const source = maskCtx.getImageData(0, 0, canvas.width, canvas.height);
    for(let i = 3; i < result.data.length; i += 4)result.data[i] = source.data[i];
    ctx.putImageData(result, 0, 0);
}
function $88f1525ed393d6e7$export$967bd8d987b25e8b(image) {
    const { width: width, height: height } = (0, $7JAKl.sizeOf)(image);
    const longest = Math.max(width, height);
    if (longest <= $88f1525ed393d6e7$export$7a9e452c85461233) return null;
    return `This picture is ${width} by ${height}. Upscaling is for pictures that are ` + `too small, and there is nothing here to invent. The limit is ${$88f1525ed393d6e7$export$7a9e452c85461233} ` + `pixels on the longest edge, because the work grows with the picture: this one ` + `would take about ${Math.round(width * height / 14000)} seconds and more memory ` + `than a browser tab will give.`;
}
async function $88f1525ed393d6e7$export$37563e0874ad125d(image, { onDownload: onDownload, onStage: onStage, onProgress: onProgress } = {}) {
    const reason = $88f1525ed393d6e7$export$967bd8d987b25e8b(image);
    if (reason) throw new Error(reason);
    if (onStage) onStage('Preparing the model');
    const session = await (0, $8hRDK.sessionFor)($88f1525ed393d6e7$export$12625b631ae5ca7f, onDownload);
    const ort = await (0, $8hRDK.loadRuntime)();
    const { width: width, height: height } = (0, $7JAKl.sizeOf)(image);
    const source = $88f1525ed393d6e7$var$toCanvas(image, width, height);
    const sourceCtx = source.getContext('2d', {
        willReadFrequently: true
    });
    const out = document.createElement('canvas');
    out.width = width * $88f1525ed393d6e7$export$fae5d17304677194;
    out.height = height * $88f1525ed393d6e7$export$fae5d17304677194;
    const outCtx = out.getContext('2d');
    const strips = Math.ceil(height / $88f1525ed393d6e7$var$STRIP_ROWS);
    for(let i = 0; i < strips; i += 1){
        const top = i * $88f1525ed393d6e7$var$STRIP_ROWS;
        const rows = Math.min($88f1525ed393d6e7$var$STRIP_ROWS, height - top);
        // The padding is only what is actually there: the first strip has
        // nothing above it and the last nothing below.
        const padTop = Math.min($88f1525ed393d6e7$var$STRIP_PAD, top);
        const padBottom = Math.min($88f1525ed393d6e7$var$STRIP_PAD, height - (top + rows));
        const readTop = top - padTop;
        const readRows = rows + padTop + padBottom;
        if (onStage) onStage(strips > 1 ? `Working, strip ${i + 1} of ${strips}` : 'Working');
        const data = sourceCtx.getImageData(0, readTop, width, readRows);
        const feeds = {
            [session.inputNames[0]]: $88f1525ed393d6e7$var$toTensor(ort, data, width, readRows)
        };
        const result = await session.run(feeds);
        $88f1525ed393d6e7$var$paint(outCtx, result[session.outputNames[0]], width * $88f1525ed393d6e7$export$fae5d17304677194, readRows * $88f1525ed393d6e7$export$fae5d17304677194, top * $88f1525ed393d6e7$export$fae5d17304677194, padTop * $88f1525ed393d6e7$export$fae5d17304677194, rows * $88f1525ed393d6e7$export$fae5d17304677194);
        if (onProgress) onProgress((i + 1) / strips);
    }
    if ((0, $7JAKl.hasAlpha)(image)) {
        if (onStage) onStage('Putting the transparency back');
        $88f1525ed393d6e7$var$restoreAlpha(out, image, width, height);
    }
    return out;
}
function $88f1525ed393d6e7$export$a417b8d6bd5b6e5(canvas, scale) {
    if (scale >= $88f1525ed393d6e7$export$fae5d17304677194) return canvas;
    const out = document.createElement('canvas');
    out.width = Math.max(1, Math.round(canvas.width / $88f1525ed393d6e7$export$fae5d17304677194 * scale));
    out.height = Math.max(1, Math.round(canvas.height / $88f1525ed393d6e7$export$fae5d17304677194 * scale));
    const ctx = out.getContext('2d');
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(canvas, 0, 0, out.width, out.height);
    return out;
}



var $8hRDK = parcelRequire("8hRDK");

var $7JAKl = parcelRequire("7JAKl");

var $65gAn = parcelRequire("65gAn");

var $iPsZ0 = parcelRequire("iPsZ0");

var $5Yt4b = parcelRequire("5Yt4b");

var $1Euqv = parcelRequire("1Euqv");
const $16635c2dd957b278$var$FORMATS = {
    'image/png': {
        label: 'PNG',
        extension: 'png',
        quality: undefined
    },
    'image/webp': {
        label: 'WebP',
        extension: 'webp',
        quality: 0.92
    },
    'image/jpeg': {
        label: 'JPEG',
        extension: 'jpg',
        quality: 0.92
    }
};
const $16635c2dd957b278$var$el = (id)=>document.getElementById(id);
const $16635c2dd957b278$var$dom = {
    zone: $16635c2dd957b278$var$el('upZone'),
    input: $16635c2dd957b278$var$el('upInput'),
    empty: $16635c2dd957b278$var$el('upEmpty'),
    workspace: $16635c2dd957b278$var$el('upWorkspace'),
    stage: $16635c2dd957b278$var$el('upStage'),
    image: $16635c2dd957b278$var$el('upImage'),
    compare: $16635c2dd957b278$var$el('upCompare'),
    factor: $16635c2dd957b278$var$el('upFactor'),
    format: $16635c2dd957b278$var$el('upFormat'),
    status: $16635c2dd957b278$var$el('upStatus'),
    statusText: $16635c2dd957b278$var$el('upStatusText'),
    progress: $16635c2dd957b278$var$el('upProgress'),
    progressBar: $16635c2dd957b278$var$el('upProgressBar'),
    error: $16635c2dd957b278$var$el('upError'),
    errorText: $16635c2dd957b278$var$el('upErrorText'),
    retry: $16635c2dd957b278$var$el('upRetry'),
    live: $16635c2dd957b278$var$el('upLive'),
    meta: $16635c2dd957b278$var$el('upMeta'),
    save: $16635c2dd957b278$var$el('upSave'),
    reset: $16635c2dd957b278$var$el('upReset'),
    saveAccount: $16635c2dd957b278$var$el('toolSaveAccount'),
    savePanel: $16635c2dd957b278$var$el('toolSavePanel'),
    saveList: $16635c2dd957b278$var$el('toolSaveList'),
    saveError: $16635c2dd957b278$var$el('toolSaveError')
};
// The last thing onStage said, so onProgress can move the bar without having
// to read the label back out of the DOM to keep it.
let $16635c2dd957b278$var$stage = '';
const $16635c2dd957b278$var$state = {
    file: null,
    image: null,
    sourceUrl: null,
    transparent: false,
    full: null,
    output: null,
    running: false
};
function $16635c2dd957b278$var$setStatus(text, fraction) {
    // The live region hears each new stage once; the bar's percentages are
    // left to the progressbar role, which a screen reader can ask for.
    if (text && text !== $16635c2dd957b278$var$stage) $16635c2dd957b278$var$dom.live.textContent = text;
    if (text !== undefined) $16635c2dd957b278$var$stage = text;
    $16635c2dd957b278$var$dom.status.hidden = !$16635c2dd957b278$var$stage;
    $16635c2dd957b278$var$dom.statusText.textContent = $16635c2dd957b278$var$stage;
    $16635c2dd957b278$var$dom.progress.hidden = fraction === undefined;
    if (fraction !== undefined) {
        const percent = Math.round(fraction * 100);
        $16635c2dd957b278$var$dom.progressBar.style.width = `${percent}%`;
        $16635c2dd957b278$var$dom.progress.setAttribute('aria-valuenow', String(percent));
    }
}
/**
 * Show a problem, or clear it with an empty message.
 *
 * @param {string} message
 * @param {object} [options]
 * @param {boolean} [options.retry]   Offer "Try again", for a download that failed.
 * @param {boolean} [options.notice]  A refusal rather than a failure, shown in amber.
 */ function $16635c2dd957b278$var$setError(message, { retry: retry = false, notice: notice = false } = {}) {
    $16635c2dd957b278$var$dom.error.hidden = !message;
    $16635c2dd957b278$var$dom.errorText.textContent = message || '';
    $16635c2dd957b278$var$dom.retry.hidden = !(message && retry);
    $16635c2dd957b278$var$dom.error.classList.toggle('bg-red-50', !notice);
    $16635c2dd957b278$var$dom.error.classList.toggle('dark:bg-red-950/30', !notice);
    $16635c2dd957b278$var$dom.error.classList.toggle('border-red-200/50', !notice);
    $16635c2dd957b278$var$dom.error.classList.toggle('dark:border-red-800/50', !notice);
    $16635c2dd957b278$var$dom.error.classList.toggle('text-red-700', !notice);
    $16635c2dd957b278$var$dom.error.classList.toggle('dark:text-red-300', !notice);
    $16635c2dd957b278$var$dom.error.classList.toggle('bg-amber-50', notice);
    $16635c2dd957b278$var$dom.error.classList.toggle('dark:bg-amber-950/30', notice);
    $16635c2dd957b278$var$dom.error.classList.toggle('border-amber-200/50', notice);
    $16635c2dd957b278$var$dom.error.classList.toggle('dark:border-amber-800/50', notice);
    $16635c2dd957b278$var$dom.error.classList.toggle('text-amber-800', notice);
    $16635c2dd957b278$var$dom.error.classList.toggle('dark:text-amber-200', notice);
}
function $16635c2dd957b278$var$releaseOutput() {
    if ($16635c2dd957b278$var$state.output) URL.revokeObjectURL($16635c2dd957b278$var$state.output.url);
    $16635c2dd957b278$var$state.output = null;
}
/**
 * Encode the result at the chosen factor.
 *
 * The network only knows four times. Two and three are that answer resampled
 * down, which is not a compromise: shrinking an upscale keeps the invented
 * detail and loses only the pixels that were carrying it.
 */ async function $16635c2dd957b278$var$present() {
    if (!$16635c2dd957b278$var$state.full) return;
    const factor = Number($16635c2dd957b278$var$dom.factor.value) || (0, $88f1525ed393d6e7$export$fae5d17304677194);
    const format = $16635c2dd957b278$var$FORMATS[$16635c2dd957b278$var$dom.format.value] || $16635c2dd957b278$var$FORMATS['image/png'];
    const canvas = (0, $88f1525ed393d6e7$export$a417b8d6bd5b6e5)($16635c2dd957b278$var$state.full, factor);
    const blob = await (0, $7JAKl.encode)(canvas, $16635c2dd957b278$var$dom.format.value, format.quality);
    $16635c2dd957b278$var$releaseOutput();
    $16635c2dd957b278$var$state.output = {
        blob: blob,
        name: (0, $7JAKl.renameExtension)($16635c2dd957b278$var$state.file.name, format.extension),
        url: URL.createObjectURL(blob)
    };
    if ($16635c2dd957b278$var$dom.compare.getAttribute('aria-pressed') !== 'true') $16635c2dd957b278$var$dom.image.src = $16635c2dd957b278$var$state.output.url;
    // Squares behind the preview only where the picture actually has holes.
    // JPEG has no alpha to keep, so it never gets them.
    $16635c2dd957b278$var$dom.stage.classList.toggle('is-transparent', $16635c2dd957b278$var$state.transparent && $16635c2dd957b278$var$dom.format.value !== 'image/jpeg');
    const source = (0, $7JAKl.sizeOf)($16635c2dd957b278$var$state.image);
    $16635c2dd957b278$var$dom.save.disabled = false;
    $16635c2dd957b278$var$dom.meta.textContent = `${source.width} x ${source.height} to ${canvas.width} x ${canvas.height}` + ` - ${(0, $7JAKl.formatBytes)(blob.size)} - ${$16635c2dd957b278$var$state.output.name}`;
}
async function $16635c2dd957b278$var$run() {
    if (!$16635c2dd957b278$var$state.image || $16635c2dd957b278$var$state.running) return;
    $16635c2dd957b278$var$state.running = true;
    $16635c2dd957b278$var$dom.save.disabled = true;
    $16635c2dd957b278$var$setError('');
    try {
        $16635c2dd957b278$var$state.full = await (0, $88f1525ed393d6e7$export$37563e0874ad125d)($16635c2dd957b278$var$state.image, {
            onDownload: (fraction)=>$16635c2dd957b278$var$setStatus(`Downloading the model, ${(0, $7JAKl.formatBytes)((0, $88f1525ed393d6e7$export$12625b631ae5ca7f).bytes)} once`, fraction),
            onStage: (text)=>$16635c2dd957b278$var$setStatus(text),
            // Leaves the label alone and only moves the bar: onStage has
            // already said which strip this is.
            onProgress: (fraction)=>$16635c2dd957b278$var$setStatus(undefined, fraction)
        });
        $16635c2dd957b278$var$setStatus('Rendering');
        await $16635c2dd957b278$var$present();
        $16635c2dd957b278$var$setStatus('');
    } catch (err) {
        $16635c2dd957b278$var$setStatus('');
        $16635c2dd957b278$var$setError((0, $8hRDK.explainLoadError)(err), {
            retry: true
        });
    } finally{
        $16635c2dd957b278$var$state.running = false;
    }
}
function $16635c2dd957b278$var$reset() {
    $16635c2dd957b278$var$releaseOutput();
    if ($16635c2dd957b278$var$state.sourceUrl) URL.revokeObjectURL($16635c2dd957b278$var$state.sourceUrl);
    if ($16635c2dd957b278$var$state.image?.close) $16635c2dd957b278$var$state.image.close();
    $16635c2dd957b278$var$state.file = null;
    $16635c2dd957b278$var$state.image = null;
    $16635c2dd957b278$var$state.sourceUrl = null;
    $16635c2dd957b278$var$state.transparent = false;
    $16635c2dd957b278$var$state.full = null;
    $16635c2dd957b278$var$stage = '';
    $16635c2dd957b278$var$dom.image.removeAttribute('src');
    $16635c2dd957b278$var$dom.workspace.hidden = true;
    $16635c2dd957b278$var$dom.empty.hidden = false;
    $16635c2dd957b278$var$dom.compare.setAttribute('aria-pressed', 'false');
    $16635c2dd957b278$var$dom.save.disabled = true;
    $16635c2dd957b278$var$dom.meta.textContent = '';
    $16635c2dd957b278$var$setStatus('');
    $16635c2dd957b278$var$setError('');
}
async function $16635c2dd957b278$var$open([file]) {
    if (!file) return;
    $16635c2dd957b278$var$reset();
    $16635c2dd957b278$var$state.file = file;
    let image;
    try {
        image = await (0, $7JAKl.decode)(file);
    } catch (err) {
        $16635c2dd957b278$var$dom.empty.hidden = true;
        $16635c2dd957b278$var$dom.workspace.hidden = false;
        $16635c2dd957b278$var$setError(err.message || 'Could not read this image');
        return;
    }
    // Checked before anything is shown, so a picture that cannot be worked on
    // never gets a workspace that looks like it is about to do something.
    const refuse = (0, $88f1525ed393d6e7$export$967bd8d987b25e8b)(image);
    if (refuse) {
        if (image.close) image.close();
        $16635c2dd957b278$var$dom.empty.hidden = true;
        $16635c2dd957b278$var$dom.workspace.hidden = false;
        $16635c2dd957b278$var$setError(refuse, {
            notice: true
        });
        const source = (0, $7JAKl.sizeOf)(image);
        $16635c2dd957b278$var$dom.meta.textContent = `${source.width} x ${source.height}, over the ${0, $88f1525ed393d6e7$export$7a9e452c85461233} pixel limit`;
        return;
    }
    $16635c2dd957b278$var$state.image = image;
    $16635c2dd957b278$var$state.transparent = (0, $7JAKl.hasAlpha)(image);
    $16635c2dd957b278$var$state.sourceUrl = URL.createObjectURL(file);
    $16635c2dd957b278$var$dom.image.src = $16635c2dd957b278$var$state.sourceUrl;
    const source = (0, $7JAKl.sizeOf)(image);
    $16635c2dd957b278$var$dom.meta.textContent = `${source.width} x ${source.height}`;
    $16635c2dd957b278$var$dom.empty.hidden = true;
    $16635c2dd957b278$var$dom.workspace.hidden = false;
    $16635c2dd957b278$var$run();
}
function $16635c2dd957b278$var$toggleCompare() {
    const showingOriginal = $16635c2dd957b278$var$dom.compare.getAttribute('aria-pressed') === 'true';
    const next = !showingOriginal;
    $16635c2dd957b278$var$dom.compare.setAttribute('aria-pressed', String(next));
    if (next) $16635c2dd957b278$var$dom.image.src = $16635c2dd957b278$var$state.sourceUrl;
    else if ($16635c2dd957b278$var$state.output) $16635c2dd957b278$var$dom.image.src = $16635c2dd957b278$var$state.output.url;
}
function $16635c2dd957b278$var$init() {
    if (!$16635c2dd957b278$var$dom.zone) return;
    (0, $65gAn.blockStrayDrops)();
    (0, $65gAn.wirePicker)({
        zone: $16635c2dd957b278$var$dom.zone,
        input: $16635c2dd957b278$var$dom.input,
        multiple: false,
        onFiles: $16635c2dd957b278$var$open
    });
    // The factor and the format only re-encode what is already computed, so
    // neither of them runs the network again.
    for (const control of [
        $16635c2dd957b278$var$dom.factor,
        $16635c2dd957b278$var$dom.format
    ])control.addEventListener('change', ()=>{
        $16635c2dd957b278$var$present().catch((err)=>$16635c2dd957b278$var$setError(err.message || 'Could not render the result'));
    });
    $16635c2dd957b278$var$dom.compare.addEventListener('click', $16635c2dd957b278$var$toggleCompare);
    $16635c2dd957b278$var$dom.retry.addEventListener('click', ()=>{
        $16635c2dd957b278$var$setError('');
        $16635c2dd957b278$var$run();
    });
    $16635c2dd957b278$var$dom.save.addEventListener('click', ()=>{
        if ($16635c2dd957b278$var$state.output) (0, $7JAKl.saveBlob)($16635c2dd957b278$var$state.output.blob, $16635c2dd957b278$var$state.output.name);
    });
    $16635c2dd957b278$var$dom.reset.addEventListener('click', $16635c2dd957b278$var$reset);
    (0, $5Yt4b.wireOffline)({
        root: document.getElementById('upOffline'),
        button: document.getElementById('upOfflineButton'),
        note: document.getElementById('upOfflineNote'),
        model: ()=>(0, $88f1525ed393d6e7$export$12625b631ae5ca7f)
    });
    (0, $iPsZ0.wireCopy)({
        button: document.getElementById('upCopy'),
        mirror: $16635c2dd957b278$var$dom.save,
        collect: ()=>$16635c2dd957b278$var$state.output
    });
    (0, $1Euqv.wireAccountSave)({
        button: $16635c2dd957b278$var$dom.saveAccount,
        panel: $16635c2dd957b278$var$dom.savePanel,
        list: $16635c2dd957b278$var$dom.saveList,
        error: $16635c2dd957b278$var$dom.saveError,
        collect: ()=>$16635c2dd957b278$var$state.output ? [
                {
                    blob: $16635c2dd957b278$var$state.output.blob,
                    name: $16635c2dd957b278$var$state.output.name
                }
            ] : []
    });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $16635c2dd957b278$var$init);
else $16635c2dd957b278$var$init();

})();
//# sourceMappingURL=tools-upscale.a11fde15.js.map
